import script from "./SurveyCard.vue?vue&type=script&setup=true&lang=js"
export * from "./SurveyCard.vue?vue&type=script&setup=true&lang=js"

import "./SurveyCard.vue?vue&type=style&index=0&id=460e2b0b&scoped=true&lang=css"

import exportComponent from "/Users/emmanueledurante/Documents/Lavoro/Martech/Whappy1/whappy-app-front-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-460e2b0b"]])

export default __exports__